import { ReactElement } from "react";
import { Container, Paper, Stack } from '@mui/material';

// components
import { IntroSection } from "../home/components/IntroSection";
import { WorksSection } from "./WorksSection";
import { ServicesSection } from "../services/ServicesSection";


const ProdFlexFlowPage = (): ReactElement => {

  return (
    <Container sx={{ my: 1, pt: 9, width: 720 }}>
      asdfasdf
    </Container>
  );
};

export default ProdFlexFlowPage;
